/**
 * Returns a number (the index) that is between 0 and the
 * number of dropdown options.
 *
 * @param {number} highlightedOptionIndex
 * @param {number} dropdownOptionsLength
 * @return {*}  {number}
 */
export var getHighlightedIndex = function (highlightedOptionIndex, dropdownOptionsLength) {
    var highlightedIndexWithinBoundary = highlightedOptionIndex % dropdownOptionsLength;
    return highlightedIndexWithinBoundary < 0
        ? dropdownOptionsLength + highlightedIndexWithinBoundary
        : highlightedIndexWithinBoundary;
};
//# sourceMappingURL=getHighlightedIndex.js.map